export default __webpack_public_path__ + "static/Major-Expenses-Remote-Workers-Travel-0a764a74855a62f246efbbeabad0abc7.jpg";